

// import React from "react";
// import { format } from 'date-fns';
// import { consumableStatus } from "../../../components/formComponents/CommonFunctions";
// import { Badge } from "antd";

// // Function to get formatted entry date
// function getEntryDate(params) {
//   return `${format(new Date(params.row.created_at), 'dd-MMM-yy')}`;
// }

// // Base columns
// const baseColumns = [
//   { key: "1", headerName: "S.No", field: "S.No", hide: false, width: 80 },
//   {
//     key: "2",
//     headerName: "Outlet Code",
//     field: "outlet_code",
//     hide: false,
//     width: 120,
//   },
//   {
//     key: "3",
//     headerName: "Outlet Name",
//     field: "outlet_name",
//     hide: false,
//     width: 250,
//   },
//   {
//     key: "4",
//     headerName: "Date",
//     field: "created_at",
//     hide: false,
//     width: 100,
//     valueGetter: getEntryDate,
//   },
//   {
//     key: "5",
//     headerName: "Status",
//     field: "consumstatus",
//     hide: false,
//     width: 150,
//     renderCell: (params) => {
//       return (
//         <Badge
//           style={{ backgroundColor: consumableStatus(params.row.consumstatus) }}
//           count={params.row.consumstatus}
//         />
//       );
//     },
//   },
// ];

// // Function to generate dynamic columns based on material descriptions
// export const generateColumns = (data) => {
//   if (!data) {
//     return baseColumns;
//   }

//   // Extract all unique material descriptions
//   const materialDescriptions = new Set();
//   data.forEach(row => {
//     row.material_group.forEach(group => {
//       if (group.description) {
//         group.description.forEach(desc => {
//           materialDescriptions.add(desc.material_description);
//         });
//       }
//     });
//   });

//   // Generate columns for each material description
//   const materialColumns = [];
//   let columnIndex = 6; // Starting index for material columns

//   materialDescriptions.forEach(description => {
//     materialColumns.push({
//       key: `${columnIndex}`,
//       headerName: description,
//       field: description,
//       hide: false,
//       width: 150,
//       valueGetter: (params) => {
//         for (const matGroup of params.row.material_group) {
//           if (matGroup.description) {
//             for (const desc of matGroup.description) {
//               if (desc.material_description === description) {
//                 return desc.stock_qty;
//               }
//             }
//           }
//         }
//         return ''; // Default value if not found
//       }
//     });
//     columnIndex++;
//   });

//   return [...baseColumns, ...materialColumns];
// };


import { format } from "date-fns";


// Base columns
const baseColumns = [
  { key: "1", headerName: "S.No", field: "S.No", hide: false, width: 80 },
  {
    key: "2",
    headerName: "Outlet Name",
    field: "outlet_name",
    hide: false,
    width: 250,
  },
  {
    key: "3",
    headerName: "Category Name",
    field: "category_name",
    hide: false,
    width: 200,
  },
 
  {
    key: "5",
    headerName: "Consumable Qty",
    field: "qty_consumable",
    hide: false,
    width: 150,
  },
  {
    key: "6",
    headerName: "Sales Qty",
    field: "qty_sales",
    hide: false,
    width: 150,
  },
 
];
console.log(baseColumns,'baseColumns');
export const generateDataRows = (consumableData = [], salesData = {}) => {
  if (!Array.isArray(consumableData) || typeof salesData !== "object") {
    console.error("Invalid data passed to generateDataRows");
    return [];
  }
  const rows = [];
  let serialNumber = 1;

  consumableData.forEach((consumableItem) => {
    const salesItem = salesData[consumableItem.outlet_code] || {};
    const salesMaterialGroups = salesItem.material_group_sales || [];

    if (consumableItem.material_group.length > 0) {
      consumableItem.material_group.forEach((consumableGroup) => {
        const salesGroup = salesMaterialGroups.find(
          (group) => group.category_name === consumableGroup.category_name
        ) || { qty_sales: 0 };

        rows.push({
          id: serialNumber++,
          outlet_name: consumableItem.outlet_name,
          category_name: consumableGroup.category_name,
          date: format(new Date(consumableItem.created_at), "dd-MMM-yy"),
          qty_consumable: consumableGroup.qty_consumable || 0,
          qty_sales: salesGroup.qty_sales || 0,
          consumstatus: consumableItem.consumstatus,
        });
      });
    } else {
      rows.push({
        id: serialNumber++,
        outlet_name: consumableItem.outlet_name,
        category_name: "",
        date: format(new Date(consumableItem.created_at), "dd-MMM-yy"),
        qty_consumable: 0,
        qty_sales: 0,
        consumstatus: consumableItem.consumstatus,
      });
    }
  });

  return rows;
};



// Main function to generate columns
// export const generateColumns = () => {
//   return baseColumns;
// };

export const generateColumns = (data) => {
  if (!data || !Array.isArray(data)) {
    console.warn('No valid data provided');
    return []; // Return an empty array instead of an empty string
  }

  // Extract all unique material descriptions
  const materialDescriptions = new Set();
  data.forEach(row => {
    row.material_group.forEach(group => {
      if (group.description) {
        group.description.forEach(desc => {
          materialDescriptions.add(desc.material_description);
        });
      }
    });
  });

  // Generate columns for each material description
  const materialColumns = [];
  let columnIndex = 6; // Starting index for material columns

  materialDescriptions.forEach(description => {
    materialColumns.push({
      key: `${columnIndex}`,
      headerName: description,
      field: description,
      hide: false,
      width: 150,
      valueGetter: (params) => {
        for (const matGroup of params.row.material_group) {
          if (matGroup.description) {
            for (const desc of matGroup.description) {
              if (desc.material_description === description) {
                return desc.stock_qty;
              }
            }
          }
        }
        return ''; // Default value if not found
      }
    });
    columnIndex++;
  });

  return [...baseColumns, ...materialColumns];
};
console.log(generateColumns,'generateColumns');